
import React from 'react';
import { useNavigate } from 'react-router-dom';
import DashboardLayout from '../components/DashboardLayout';
import PublicStrategyList from '../components/Strategy/PublicStrategyList/PublicStrategyList';

const PublicStrategies = () => {
    const navigate = useNavigate();

    const handleCopyStrategy = (strategy) => {
        // Navigate to create page with imported strategy
        navigate('/dashboard/strategies', {
            state: {
                importedStrategy: strategy,
                tab: 'create'
            }
        });
    };

    return (
        <DashboardLayout>
            <div className="h-full bg-base-200 p-4 overflow-auto">
                <PublicStrategyList onCopyStrategy={handleCopyStrategy} />
            </div>
        </DashboardLayout>
    );
};

export default PublicStrategies;
